/**
 * Path for crops table
 */
export const indexPath = '/crops';